import { atom } from "jotai";
import { uniqBy } from "lodash";

export const selectedProviderAtom = atom(null);

export const selectedProviderServicesAtom = atom((get) => {
  const provider = get(selectedProviderAtom);
  if (provider && provider.servicetypes && provider.servicetypes.items) {
    const providerServices = uniqBy(
      provider.servicetypes.items.map((item) => item.servicetype),
      "id"
    );
    const activeProviderServices = providerServices.filter((service) => {
      return (
        service.active !== false &&
        service.deleted !== true &&
        service.isVisible !== false
      );
    });
    const sortedServices = activeProviderServices.sort((s1, s2) => {
      if (s1?.category?.ordinal > s2?.category?.ordinal) return 1;
      if (s1?.category?.ordinal < s2?.category?.ordinal) return -1;
      if (s1?.category?.id === s2?.category?.id) {
        if (s1.ordinal > s2.ordinal) return 1;
        if (s1.ordinal < s2.ordinal) return -1;
        return 0;
      }
      return 0;
    });

    return sortedServices;
  }

  return [];
});

export const allServicesAtom = atom(null);

export const allActiveServicesAtom = atom((get) => {
  const allServices = get(allServicesAtom);
  if (!allServices || !Array.isArray(allServices)) {
    return [];
  }

  const activeServices = allServices.filter((service) => {
    return (
      service.active !== false &&
      service.deleted !== true &&
      service.isVisible !== false
    );
  });

  return activeServices;
});

export const allPublicServicesAtom = atom((get) => {
  const activeServices = get(allActiveServicesAtom);
  if (!activeServices || !Array.isArray(activeServices)) {
    return [];
  }
  const publicServices = activeServices.filter(
    (service) => service.behavior !== "INTERNAL"
  );

  return publicServices;
});
